// extracted by mini-css-extract-plugin
export default {"root":"PayPal_root__rCjyX","form":"PayPal_form__KWfE7"};